import { render } from "./MevRewardsClaimer.vue?vue&type=template&id=5e671f48"
import script from "./MevRewardsClaimer.vue?vue&type=script&lang=js"
export * from "./MevRewardsClaimer.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/MevRewardsClaimer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e671f48"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e671f48', __exports__)) {
    api.reload('5e671f48', __exports__)
  }
  
  module.hot.accept("./MevRewardsClaimer.vue?vue&type=template&id=5e671f48", () => {
    api.rerender('5e671f48', render)
  })

}


export default __exports__